import { RegistryItem } from "@schemas/calculationmethods/schema";
import LumpsumCalculationMethodForm from "view/calculationmethods/components/form/LumpsumCalculationMethodForm";
import { CalculationMethodType } from "__generated__/graphql";
import LumpsumCalculationMethodDetails from "view/calculationmethods/components/details/LumpsumCalculationMethodDetails";

export const LumpsumSchema: RegistryItem = {
	[CalculationMethodType.Lumpsum]: {
		Form: LumpsumCalculationMethodForm,
		Details: LumpsumCalculationMethodDetails,
		fields: {
			"calculationMethod.price": { path: "price", rules: { required: true } },
		},
		toInput: (form) => ({
			lumpsumCalculationMethodInput: {
				id: form.id ?? undefined,
				price: form.price ?? undefined,
			},
		}),
	},
};
